export const FormFieldSavingEventType = "formFieldSuccess"
export enum FormFieldSavingStatus {
    SAVING = "saving",
    SUCCESS = "success",
    ERROR = "error"
}
export type FormFieldSavingCustomEventPayload = {status: FormFieldSavingStatus}
export type FormFieldSavingCustomEvent = CustomEvent<FormFieldSavingCustomEventPayload>;